import React, {Component}from 'react';
import {BrowserRouter, Route} from 'react-router-dom';
import { Provider } from 'react-redux';

import './App.css';

import store from './store'
import Siteheader from './components/layout/Siteheader'
import Searchbar from './components/Searchbar'
import Menubar from './components/Menubar'
import Sitefooter from './components/layout/Sitefooter'
import './utils/axios.js';

import Homepage from './components/layout/pages/Homepage'
import Catpage from './components/layout/pages/Categorypage'
import Searchpage from './components/layout/pages/Searchpage'
import Productpage from './components/layout/pages/Productpage'
import AlertBar from './components/Alertbar'
import Cartpage from './components/layout/pages/Cartpage'
import Checkoutpage from './components/layout/pages/Checkoutpage'
import Review from './components/layout/pages/Reviewpage'
import OrderConfirmation from './components/layout/pages/OrderConfirmationpage'
import OrderTracking from './components/layout/pages/OrderTrackingpage' 
import Marketingpage from './components/layout/pages/Marketpage'

class App extends Component {
  render(){
    return (
      <Provider store={store}>
        <BrowserRouter>
          <div className="App">
            <div className="container-fluid">
              <header>
                <Siteheader />
                <Searchbar />
                {/* <Menubar /> */}
              </header>
              <AlertBar/>
              <article style={{ maxWidth: '1440px', margin: '0 auto', width: '100%' }}>
                <Route exact  path="/" component={Homepage} />
                <Route exact  path="/products" component={Catpage} />
                <Route exact  path="/s/:searchterm" component={Searchpage} />
                <Route exact  path="/p/:name/:id" component={Productpage} />
                <Route exact  path="/cart" component={Cartpage} />
                <Route exact  path="/checkout" component={Checkoutpage}/>
                <Route exact  path="/review" component={Review}/>
                <Route exact  path="/oc" component={OrderConfirmation}/>
                <Route exact  path="/ot" component={OrderTracking}/>
                <Route exact  path="/m/refund" component={Marketingpage}/>
                <Route exact  path="/m/tnc" component={Marketingpage}/>
                <Route exact  path="/m/ppolicy" component={Marketingpage}/>
              </article>
              <Sitefooter />
            </div>
          </div>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default App;
